export default __webpack_public_path__ + "images/logo@2x.png";